export default "__VITE_PUBLIC_ASSET__ff7abc0f__"